import { render } from "./PdfHzbaTemplate.vue?vue&type=template&id=48b50250&scoped=true&ts=true"
import script from "./PdfHzbaTemplate.vue?vue&type=script&lang=ts"
export * from "./PdfHzbaTemplate.vue?vue&type=script&lang=ts"

import "./PdfHzbaTemplate.vue?vue&type=style&index=0&id=48b50250&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b50250"]])

export default __exports__